(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hp-benefits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('js-hp');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    function scan() { document.querySelectorAll('.hp-reveal:not(.is-in)').forEach(function (el) { io.observe(el); }); }
    scan();
    document.addEventListener('shopify:section:load', scan);
    setTimeout(function () { document.querySelectorAll('.hp-reveal').forEach(function (el) { el.classList.add('is-in'); }); }, 4000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var finePointer = window.matchMedia('(pointer: fine)').matches;
    document.querySelectorAll('[data-hp-stage]').forEach(function (stage) {
      var raf = null;
      function set(rx, ry) {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          stage.style.setProperty('--rx', rx.toFixed(2) + 'deg');
          stage.style.setProperty('--ry', ry.toFixed(2) + 'deg');
        });
      }
      if (finePointer) {
        stage.addEventListener('pointermove', function (e) {
          var r = stage.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          set(-y * 14, x * 18);
        });
        stage.addEventListener('pointerleave', function () { set(0, 0); });
      } else {
        var onScroll = function () {
          var r = stage.getBoundingClientRect();
          var p = Math.max(-1, Math.min(1, (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight));
          set(p * 8, p * -10);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
